import React, {useEffect, useRef} from 'react'

import {Button, Form, Input, message, Modal, Upload} from 'antd'
import {UploadOutlined} from '@ant-design/icons'
import {getFileNameByUrl} from "../../app/util";

const {TextArea} = Input

const MediaForm = ({visible, onSubmit, onCancel, media, customRequest}) => {
    //destructures props
    const [form] = Form.useForm()
    const formRef = useRef()

    useEffect(() => {
        formRef.current?.setFieldsValue({
            title: media.title,
            subtitle: media.subtitle,
            description: media.desc,
            location: media.location,
            year: media.year,
            end_year: media.end_year === -1 ? '' : media.end_year,
            thumbnails: media.thumbnails ? [
                    {
                        name: getFileNameByUrl(media.thumbnails),
                        status: 'done',
                        thumbUrl: media.thumbnails,
                        url: media.thumbnails
                    }
                ]
                : [],
            link: media.link
        })
    }, [media])

    return (
        media && (
            <Modal
                visible={visible}
                title='Add News'
                okText='Submit'
                onCancel={onCancel}
                width={800}
                onOk={() => {
                    form
                        .validateFields(['title'])
                        .then((values) => {
                            //form.resetFields();
                            onSubmit(form.getFieldsValue())
                        })
                        .catch((info) => {
                            message.error('Please fill out all fields').then(() => {
                            })
                        })
                }}
            >
                <Form
                    ref={formRef}
                    form={form}
                    layout='vertical'
                    name='MediaForm'
                >
                    <div>
                        <Form.Item
                            name='title'
                            label='Title'
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input the title!',
                                    type: 'string',
                                    max: 100,
                                    min: 1
                                }
                            ]}
                        >
                            <TextArea autoSize placeholder='' showCount maxLength={100}/>
                        </Form.Item>
                        <Form.Item
                            name='subtitle'
                            label='Subtitle'
                            rules={[
                                {
                                    required: false,
                                    type: 'string',
                                    max: 100,
                                    min: 1
                                }
                            ]}
                        >
                            <TextArea autoSize showCount maxLength={100}/>
                        </Form.Item>
                        <Form.Item
                            name='description'
                            label='Description'
                            rules={[
                                {
                                    required: false,
                                    type: 'string',
                                    max: 500,
                                    min: 1
                                }
                            ]}
                        >
                            <TextArea rows={3} showCount maxLength={500}/>
                        </Form.Item>
                        <Form.Item
                            name='thumbnails'
                            label='Image'
                            valuePropName='fileList'
                            getValueFromEvent={(e) => {
                                if (Array.isArray(e)) {
                                    return e
                                }
                                return e && e.fileList
                            }}
                            rules={[
                                {
                                    required: false
                                }
                            ]}
                        >
                            <Upload accept='image/*' listType='picture' customRequest={customRequest} maxCount={1}>
                                <Button icon={<UploadOutlined/>}>Upload</Button>
                            </Upload>
                        </Form.Item>
                        <Form.Item
                            name='location'
                            label='Location'
                            rules={[
                                {
                                    required: false,
                                    type: 'string',
                                    max: 100,
                                    min: 1
                                }
                            ]}
                        >
                            <TextArea autoSize placeholder='City, State, Country' showCount maxLength={100}/>
                        </Form.Item>
                        <Form.Item
                            name='link'
                            label='Link'
                            rules={[
                                {
                                    required: false,
                                    type: 'string',
                                    max: 500,
                                    min: 1
                                }
                            ]}
                        >
                            <Input prefix={'https://'}/>
                        </Form.Item>
                        <Form.Item
                            name='year'
                            label='Start Year: Ex. 2020'
                            rules={[
                                {
                                    required: false,
                                    message: 'Please a valid year!',
                                    type: 'number',
                                    transform: (value) => {
                                        return Number(value)
                                    }
                                }
                            ]}
                        >
                            <Input/>
                        </Form.Item>
                        <Form.Item
                            name='end_year'
                            label='End Year: Ex. 2023'
                            rules={[
                                {
                                    required: false,
                                    message: 'Please a valid year!',
                                    type: 'number',
                                    transform: (value) => {
                                        return Number(value)
                                    }
                                }
                            ]}
                        >
                            <Input/>
                        </Form.Item>
                    </div>
                </Form>
            </Modal>
        )
    )
}

export default MediaForm
